import { Modal, ModalProps } from '@pypestream/design-system';
import { useEffect, type FC, type PropsWithChildren } from 'react';
import { useProStudioStateMatches } from '../../../xstate/app.xstate';

export interface GenericModalProps extends ModalProps {
  modalRef: React.RefObject<ModalProps> | null;
  onClose?: () => void;
  onError?: () => void;
  testId?: string;
}

export const GenericModal: FC<PropsWithChildren<GenericModalProps>> = ({
  modalRef,
  onClose,
  onError,
  children,
  ...rest
}) => {
  const isBotFlowError = useProStudioStateMatches(
    'checkingUserInfo.projectFlow.projectDataLoaded.botFlow.botFlowError'
  );

  useEffect(() => {
    if (isBotFlowError) {
      onError?.();
    }
  }, [isBotFlowError, onError]);

  return (
    <Modal ref={modalRef} onClose={onClose} {...rest}>
      {children}
    </Modal>
  );
};
